import { Box, Header, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const Wrapper = Box.withConfig({
  marginX: 'auto',
  marginTop: '$4',
  maxWidth: {
    base: '$56',
    md: '$64',
  },
  _text: {
    textAlign: 'center',
    margin: 0,
    color: Styles.color.grey.one,
  },
  focusable: true,
});

export const Title = Header.withConfig({
  marginTop: 0,
  marginRight: 0,
  marginBottom: '3px',
  marginLeft: 0,
  paddingTop: '$1.5',
  textAlign: 'center',
  color: primitive.bk.$bbqBrown,
  fontSize: 'lg',
  variant: 'headerFour',
  focusable: true,
});

export const CancellationPolicyText = Text.withConfig({
  textAlign: 'center',
  color: primitive.bk.$bbqBrown,
});
